import { render, staticRenderFns } from "./TournamentDetailsPage.vue?vue&type=template&id=50da3af8&"
import script from "./TournamentDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TournamentDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports